import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

const PLAYERS = ['Player A', 'Player B', 'Player C', 'Player D'];

// Race to 2nd — table casino-queen. 4 players (A-D) back+lay. book-black hamesha.
// Desktop (d-none-small): col-3 casino-box-row → name / casino-bl-box (suspended
// wrapper pe) / book. Mobile (d-none-big): casino-bl-box → odds-name + float-right
// book / back / lay (suspended per-item). Neeche col-12 casino-min-max R:100-50K.
const BetTableRace2 = memo(function BetTableRace2({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});
  const players = PLAYERS.map((name) => sub.find((s) => s.nat === name));

  return (
    <>
      {/* Desktop */}
      <div className="row d-none-small">
        {players.map((item, i) => {
          const book = bookOf(exposures, PLAYERS[i]);
          return (
            <div key={i} className="col-3">
              <div className="casino-box-row">
                <div className="casino-nation-name"><b>{PLAYERS[i]}</b></div>
                {' '}
                <div className={`casino-bl-box${suspCls(item)}`}>
                  <div
                    data-toggle="modal"
                    data-target="#casino-betslip"
                    className="back casino-bl-box-item"
                    onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
                  >
                    <span className="casino-box-odd">{item?.b || 0}</span>
                  </div>
                  {' '}
                  <div
                    className="lay casino-bl-box-item"
                    onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}
                  >
                    <span className="casino-box-odd">{item?.l || 0}</span>
                  </div>
                </div>
                {' '}
                <div className="casino-nation-name">
                  <span className={`casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Mobile */}
      <div className="row row5 d-none-big">
        {players.map((item, i) => {
          const book = bookOf(exposures, PLAYERS[i]);
          return (
            <div key={i} className="casino-bl-box">
              <div className="casino-bl-box-item casino-odds-name">
                <b>{PLAYERS[i]}</b>
                {' '}
                <span className={`float-right ${bookCls(book)}`}>{fmtBook(book)}</span>
              </div>
              {' '}
              <div
                className={`back casino-bl-box-item${suspCls(item)}`}
                onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
              >
                <span className="casino-box-odd">{item?.b || 0}</span>
              </div>
              {' '}
              <div
                className={`lay casino-bl-box-item${suspCls(item)}`}
                onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}
              >
                <span className="casino-box-odd">{item?.l || 0}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* min-max */}
      <div className="col-12 text-right casino-min-max">
        {'\n              R:'}<span>100</span>-<span>50K</span>
      </div>
    </>
  );
});

export default BetTableRace2;
